import { useAtom } from 'jotai';
import {
  selectedCategoryDataAtom,
  selectedMobileBurgerTabDataAtom,
} from 'store/private/layout/layoutAtoms';

import { useNavLinks } from '../navLinks';
import { Tabs } from '../Tabs';
import { NavLinksRenderer } from './NavLinksRenderer/NavLinksRenderer';

export const MenuTabContentSwitcher = props => {
  const [selectedCategoryData] = useAtom(selectedCategoryDataAtom);
  const [selectedMobileBurgerTabData] = useAtom(
    selectedMobileBurgerTabDataAtom,
  );
  const { menuLinksMap } = useNavLinks();

  const name = selectedCategoryData.name || selectedMobileBurgerTabData.name;

  if (name === 'windows') {
    return <Tabs sidebar />;
  }

  const links = menuLinksMap[name];

  return links ? <NavLinksRenderer links={links} /> : null;
};
